import fastify from 'fastify'

import { exchangeToken } from './exchange-token'
import { loginSuccessfulHtmlResponse } from './login-successful-html'

export const generateCallbackEndpoint = ({ port }: { port: number }) =>
  new Promise<Exclude<Awaited<ReturnType<typeof exchangeToken>>, null>>(
    (resolve, reject) => {
      const app = fastify({ logger: false })

      app.get('/callback', async (req, res) => {
        const { exchangeToken: exchangeTokenQuery } = req.query as any

        if (!exchangeTokenQuery || typeof exchangeTokenQuery !== 'string') {
          res.code(400).send('Invalid exchange token')
          app.close()
          reject()
        }

        try {
          const tokens = await exchangeToken(exchangeTokenQuery)

          if (tokens) {
            res.type('text/html').send(loginSuccessfulHtmlResponse())
            app.close()
            resolve(tokens)
          } else {
            res.code(400).send('Failed to exchange token')
            app.close()
            reject()
          }
        } catch {
          res.code(500).send('Internal server error')
          app.close()
          reject()
        }
      })

      app.listen({ host: '0.0.0.0', port }).catch(() => {
        reject()
      })
    },
  )
